import { render, staticRenderFns } from "./EditPlanGroup.vue?vue&type=template&id=03150725&"
import script from "./EditPlanGroup.vue?vue&type=script&lang=js&"
export * from "./EditPlanGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports